/**
 * Payment Cancel Page
 * Shown when user cancels Stripe checkout
 */
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancelPage() {
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="w-20 h-20 bg-white/10 rounded-full flex items-center justify-center mx-auto mb-6">
          <XCircle className="w-12 h-12 text-white/40" />
        </div>
        <h1 className="text-3xl font-bold mb-2">
          Payment Cancelled
        </h1>
        <p className="text-white/60 mb-8">
          No worries! You can always upgrade later when you're ready.
        </p>
        <div className="space-y-3">
          <Link to="/pricing">
            <Button className="w-full bg-white text-black hover:bg-gray-200 h-12 font-bold rounded-sm">
              View Plans Again
            </Button>
          </Link>
          <Link to="/dashboard">
            <Button variant="outline" className="w-full border-white/20 text-white hover:bg-white/10 h-12 rounded-sm">
              Go to Dashboard
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
